/**
 * "JetBrains DataGrip" shortcut scheme (plan D7). Sources, accessed 2026-09-23, DataGrip 2026.2
 * Help — each page carries per-keymap data (Windows, XWin, GNOME, KDE, macOS) for its <kbd>s:
 *
 * [KEYS] https://www.jetbrains.com/help/datagrip/mastering-keyboard-shortcuts.html
 *   "Ctrl+Enter — In a query console: Execute Statement" (action Console.Jdbc.Execute:
 *   Ctrl+Enter on Windows/XWin/GNOME/KDE, ⌘Enter on macOS).
 * [RUN] https://www.jetbrains.com/help/datagrip/run-a-query.html
 *   "To cancel a running statement, press Ctrl+F2" (action Stop: Ctrl+F2 on
 *   Windows/XWin/GNOME, ⌘F2 on macOS).
 * [FORMAT] https://www.jetbrains.com/help/datagrip/reformat-and-rearrange-code.html
 *   Reformat Code (action ReformatCode: Ctrl+Alt+L on Windows/XWin/GNOME, ⌘⌥L on macOS).
 * [KEYMAP] https://www.jetbrains.com/help/datagrip/reference-keymap-win-default.html and
 *   https://www.jetbrains.com/help/datagrip/reference-keymap-mac-default.html
 *   Predefined keymaps: Stop Ctrl+F2 / ⌘F2, Reformat Code Ctrl+Alt+L / ⌘⌥L.
 *
 * Platforms: DataGrip documents a Windows and a macOS keymap; Linux rows follow its default
 * Linux keymaps (XWin, GNOME), which match Windows for these actions — the Ubuntu table in
 * https://www.jetbrains.com/help/datagrip/configuring-keyboard-and-mouse-shortcuts.html lists
 * Ctrl+Alt+L as Reformat Code (and as the desktop's lock-screen shortcut). The KDE keymap
 * differs (Stop Ctrl+2, Reformat Alt+Shift+L) and is not modelled. The printable reference card
 * (resources.jetbrains.com/storage/products/datagrip/docs/DataGrip_keymap.pdf) prints macOS
 * Reformat code as ⌃⌥L; the 2026.2 keymap pages above say ⌘⌥L, which is used.
 *
 * AltGr: on Windows layouts with an AltGr key (German, Polish, French…) Ctrl+Alt is AltGr,
 * which the dispatcher ignores (D5), so Mod+Alt+L cannot fire there. keyboard-shortcuts.njk
 * says so next to the Linux lock-screen note; the scheme row stays as DataGrip documents it.
 *
 * Mapping: Execute Statement ([KEYS] Ctrl+Enter / ⌘Enter) runs the statement at the caret, which
 * is Jam's Execute current statement — already `Mod+Enter` in the Jam defaults, so it needs no row.
 *
 * Left out: Shift+Enter (DataGrip: Start New Line — the Jam Execute current statement default
 * stays); running a whole script and hiding the results have no default chord of their own.
 */
import { defineScheme, onEveryPlatform } from './schemeRows';

export const dataGrip = defineScheme('datagrip', 'JetBrains DataGrip', [
  // [RUN] Stop: Ctrl+F2 / ⌘F2.
  { commandId: 'query.cancel', chords: onEveryPlatform('Mod+F2') },
  // [FORMAT] Reformat Code: Ctrl+Alt+L / ⌘⌥L.
  { commandId: 'query.formatSql', chords: onEveryPlatform('Mod+Alt+L') },
]);
